import styled from "styled-components";

export const OptionsWrapper = styled.div<{ $isColorpicker?: boolean, $isSection?: boolean }>`
  position: absolute;
  display:flex;
  flex-direction:column;
  top: 40px;
  right: 16px;
  height: ${({ $isColorpicker, $isSection }) => ($isSection ? "min-content" : $isColorpicker ? "400px" : "390px")};
  width: auto;
  z-index: 5;
  background-color: ${({ theme }) => theme.neutralBackgroundBase};
  border-radius: 6px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
`;

export const ContentWrapper = styled.div<{ $isSection?: boolean }>`
  height: ${({ $isSection }) => $isSection ? "100%" : "calc(100% - 48px)"};
  overflow-y: ${({ $isSection }) => $isSection ? "visible" : "auto"};
  overflow-x: visible !important;
  display: flex;
  flex-direction: column;
`;

export const OptionsMenuWrapper = styled.div`
  width: 283px;
  height: 36px;
  margin-top: 8px;
`;

export const OptionsMenuItemsWrapper = styled.div`
  display: flex;
  gap: 16px;
  padding-left: 16px;
  height: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.neutralBorder};
`;
export const OptionsMenuItem = styled.div<{
  $activeItem?: boolean;
  $width?: number;
}>`
  height: 36px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${({ theme, $activeItem }) =>
    $activeItem ? theme.neutralText : theme.neutralTextWeak};

  &:after {
    display: ${({ $activeItem }) => ($activeItem ? "block" : "none")};
    content: "";
    height: 2px;
    width: ${({ $width }) => `${$width}px`};
    margin-top: 37px;
    background: ${({ theme }) => theme.primaryBorder};
    position: absolute;
  }
`;
